import React from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// COMPONENTS
import TableColumnOrganizationType from "../table/TableColumnOrganizationType";
// INTERFACES
import { FormularyRowSelectOrganizationTypeInterface } from "../../../interfaces/FormularyRow";

const ORGANIZATION_TYPES: ("ORG" | "SUBORG")[] = ["ORG", "SUBORG"];

export default function FormularyRowSelectOrganizationType({
	record,
	text,
	value,
	formAction,
	itemId,
	onChangeFormValue,
}: FormularyRowSelectOrganizationTypeInterface) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Option } = Select;

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<>
			{record.id === "" ? (
				<Select
					allowClear={false}
					size='small'
					value={formAction === "create" ? value : null}
					className='generalStyles__width200px'
					onChange={(e: string) => {
						onChangeFormValue(e, "type");
					}}
				>
					{ORGANIZATION_TYPES.map((type) => (
						<Option key={type} value={type}>
							{type}
						</Option>
					))}
				</Select>
			) : (
				<>
					{formAction === "edit" && record.id === itemId ? (
						<Select
							allowClear={false}
							size='small'
							value={value}
							className='generalStyles__width200px'
							onChange={(e: string) => {
								onChangeFormValue(e, "type");
							}}
						>
							{ORGANIZATION_TYPES.map((type) => (
								<Option key={type} value={type}>
									{type}
								</Option>
							))}
						</Select>
					) : (
						<TableColumnOrganizationType type={text} />
					)}
				</>
			)}
		</>
	);
}
